import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Dotdotdot from 'react-dotdotdot';

const Description = props => {
  const {
    account,
    description,
    descriptionLines,
    itemIndex,
    link,
    name,
    onTileClick,
    originalItem,
    percentWatched,
    recommendationIdData,
    render,
    subtitleText,
    target,
    theme,
    titleText,
  } = props;
  if (!render || !description || description.length === 0) return null;
  const text = descriptionLines ? (
    <Dotdotdot clamp={descriptionLines}>{description}</Dotdotdot>
  ) : (
    description
  );
  if (!link) return <div className={theme.description}>{text}</div>;
  const onClick = () => {
    if (onTileClick)
      onTileClick({
        originalItem,
        itemIndex,
        name,
        percentWatched,
        account,
        recommendationIdData,
        subtitleText,
        titleText,
      });
  };

  return (
    <Link to={link} target={target} className={theme.description} onClick={onClick}>
      <p>{text}</p>
    </Link>
  );
};

Description.defaultProps = {
  account: null,
  description: null,
  descriptionLines: null,
  itemIndex: null,
  link: null,
  name: null,
  onTileClick: () => {},
  originalItem: null,
  percentWatched: null,
  recommendationIdData: null,
  render: true,
  subtitleText: null,
  target: null,
  theme: {},
  titleText: null,
};

Description.propTypes = {
  account: PropTypes.shape({}),
  description: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  descriptionLines: PropTypes.number,
  itemIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  link: PropTypes.string,
  name: PropTypes.string,
  onTileClick: PropTypes.func,
  originalItem: PropTypes.shape({}),
  percentWatched: PropTypes.number,
  recommendationIdData: PropTypes.oneOfType([PropTypes.node, PropTypes.shape({})]),
  render: PropTypes.bool,
  subtitleText: PropTypes.string,
  target: PropTypes.string,
  theme: PropTypes.shape({}),
  titleText: PropTypes.string,
};

export default Description;
